/* Trident 300 LP: variant selector, free second strap (one per watch), add-to-cart via cart/add.js (the store's upCart drawer is the cart UI),
   FREESTRAP applied on load, sticky CTA, count-up, chart reference line.
   Product data is injected by the section (data-tlp-products / data-tlp-config), so prices always match the store.
   Revised 2026-10-20 from the Design canvas review. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var root = $('.tlp');
  if (!root) return;
  var PRODUCTS = {}, CFG = { moneyFormat: '${{amount}}', cartUrl: '/cart', cartAddUrl: '/cart/add', cartChangeUrl: '/cart/change', freeStrap: true, discountCode: 'FREESTRAP', holdTimer: true, holdMinutes: 15 };
  try { PRODUCTS = JSON.parse($('[data-tlp-products]').textContent); delete PRODUCTS._; } catch (e) { PRODUCTS = {}; }
  try { CFG = Object.assign(CFG, JSON.parse($('[data-tlp-config]').textContent)); } catch (e) { /* defaults */ }
  if (CFG.holdTimer === null || CFG.holdTimer === undefined) CFG.holdTimer = true;
  var DEFAULT_ID = String(CFG.defaultVariant || Object.keys(PRODUCTS)[0]);
  function kindOf(id) { var p = PRODUCTS[String(id)]; return p ? p.kind : 'other'; }
  function isStrap(id) { return kindOf(id) === 'strap'; }
  function isWatch(id) { return kindOf(id) === 'watch'; }
  var KIT_ID = (function () { var k = Object.keys(PRODUCTS).filter(function (id) { return PRODUCTS[id].kind === 'kit'; })[0]; return k ? parseInt(k, 10) : null; })();

  /* Money: cents -> shop format */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return CFG.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDots)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1])
      .replace(/<[^>]+>/g, '');
  }
  function setText(sel, txt) { $$(sel, root).forEach(function (el) { el.textContent = txt; }); }

  /* ---------- Variant selector (radiogroup, roving tabindex, arrows) ---------- */
  var selected = DEFAULT_ID;
  var radios = $$('[data-variants] [role=radio]', root);
  var galleryMain = $('#gallery-main', root);

  function selectVariant(id, opts) {
    id = String(id);
    if (!PRODUCTS[id]) return;
    selected = id;
    radios.forEach(function (r) {
      var on = r.getAttribute('data-variant') === id;
      r.setAttribute('aria-checked', on ? 'true' : 'false');
      r.tabIndex = on ? 0 : -1;
      r.classList.toggle('is-selected', on);
    });
    var p = PRODUCTS[id];
    var save = Math.max(0, p.compare - p.price);
    setText('[data-receipt-variant]', p.short);
    setText('[data-receipt-compare]', money(p.compare));
    setText('[data-receipt-save]', '-' + money(save));
    setText('[data-receipt-total]', money(p.price + (CFG.freeStrap ? 0 : strapPrice())));
    setText('[data-cta-price]', money(p.price));
    setText('[data-sticky-price]', money(p.price));
    setText('[data-sticky-compare]', money(p.compare));
    if (galleryMain && !(opts && opts.keepImage)) {
      galleryMain.src = p.img;
      galleryMain.alt = p.alt;
      $$('.tlp-thumb', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === p.img); });
    }
    if (opts && opts.focus) {
      var r = radios.filter(function (x) { return x.getAttribute('data-variant') === id; })[0];
      if (r) r.focus();
    }
  }

  radios.forEach(function (r, i) {
    r.addEventListener('click', function () { selectVariant(r.getAttribute('data-variant')); });
    r.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectVariant(r.getAttribute('data-variant')); return; }
      if (!dir) return;
      e.preventDefault();
      var next = radios[(i + dir + radios.length) % radios.length];
      selectVariant(next.getAttribute('data-variant'), { focus: true });
    });
  });

  /* Gallery thumbs */
  $$('.tlp-thumb', root).forEach(function (t) {
    t.addEventListener('click', function () {
      if (!galleryMain) return;
      galleryMain.src = t.getAttribute('data-thumb');
      galleryMain.alt = t.getAttribute('data-alt') || '';
      $$('.tlp-thumb', root).forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });

  /* ---------- Second strap picker (radiogroup, roving tabindex). One strap per watch. ---------- */
  var strapRadios = $$('[data-straps] [role=radio]', root).filter(function (r) { return !r.disabled; });
  var strapSel = null;
  function strapPrice() { var p = strapSel && PRODUCTS[strapSel]; return p ? p.price : 0; }
  function selectStrap(id, opts) {
    id = String(id);
    strapSel = id;
    strapRadios.forEach(function (r) {
      var on = r.getAttribute('data-strap') === id;
      r.setAttribute('aria-checked', on ? 'true' : 'false');
      r.tabIndex = on ? 0 : -1;
      r.classList.toggle('is-selected', on);
      if (on && opts && opts.focus) r.focus();
    });
    var p = PRODUCTS[id];
    if (p) {
      setText('[data-receipt-addon-name]', p.short);
      setText('[data-receipt-addon-price]', CFG.freeStrap ? 'Free' : money(p.price));
    }
    if (PRODUCTS[selected]) setText('[data-receipt-total]', money(PRODUCTS[selected].price + (CFG.freeStrap ? 0 : strapPrice())));
  }
  strapRadios.forEach(function (r, i) {
    r.addEventListener('click', function () { selectStrap(r.getAttribute('data-strap')); });
    r.addEventListener('keydown', function (e) {
      var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectStrap(r.getAttribute('data-strap')); return; }
      if (!dir) return;
      e.preventDefault();
      var next = strapRadios[(i + dir + strapRadios.length) % strapRadios.length];
      selectStrap(next.getAttribute('data-strap'), { focus: true });
    });
  });
  if (strapRadios.length) {
    var pre = strapRadios.filter(function (r) { return r.getAttribute('aria-checked') === 'true'; })[0] || strapRadios[0];
    selectStrap(pre.getAttribute('data-strap'));
  }

  /* ---------- Shopify cart (the store's upCart drawer is the only cart UI; it opens itself on add) ---------- */
  var cartState = { items: [], item_count: 0 };
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function renderBadge() {
    var badge = $('[data-cart-count]', root);
    var n = cartState.item_count || 0;
    if (badge) { badge.textContent = String(n); badge.hidden = n === 0; }
  }
  function loadCart() { return fetchJSON(CFG.cartUrl + '.js').then(function (cart) { cartState = cart; renderBadge(); return cart; }); }
  function addLines(items) {
    return fetchJSON(CFG.cartAddUrl + '.js', { method: 'POST', body: JSON.stringify({ items: items }) }).then(loadCart);
  }
  function openStoreCart() {
    /* upCart normally opens on its own after cart/add.js; these are belt-and-braces for versions that expose an opener. */
    try {
      if (window.upcartOpenCart) { window.upcartOpenCart(); return; }
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      document.dispatchEvent(new CustomEvent('upcart:open'));
    } catch (e) { /* ignore */ }
  }
  /* Free strap: apply the FREESTRAP code once per visit so checkout zeroes the strap without the customer typing anything. */
  if (CFG.freeStrap && CFG.discountCode) {
    try {
      if (!sessionStorage.getItem('iw_tlp_discount')) {
        fetch('/discount/' + encodeURIComponent(CFG.discountCode), { credentials: 'same-origin', redirect: 'follow' })
          .then(function () { sessionStorage.setItem('iw_tlp_discount', '1'); })
          .catch(function () {});
      }
    } catch (e) { /* storage blocked: the checkout link fallback below still carries the code */ }
  }
  function cartError(err) {
    var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
    toast(msg);
  }

  /* Add to cart: the selected watch plus the selected second strap (one per watch). Every [data-add-to-cart] button on the page does the same. */
  $$('[data-add-to-cart]', root).forEach(function (addBtn) {
    addBtn.addEventListener('click', function () {
      var items = [{ id: parseInt(selected, 10), quantity: 1 }];
      if (strapSel && PRODUCTS[strapSel]) items.push({ id: parseInt(strapSel, 10), quantity: 1 });
      addBtn.setAttribute('aria-busy', 'true');
      addLines(items).then(function () {
        addBtn.removeAttribute('aria-busy');
        openStoreCart();
      }).catch(function (err) { addBtn.removeAttribute('aria-busy'); cartError(err); });
    });
  });

  /* ---------- Toast ---------- */
  var toastEl = $('[data-toast]', root), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  /* ---------- Sticky mobile CTA ---------- */
  var sticky = $('[data-sticky]', root);
  var hero = $('#hero', root), buy = $('#buy', root);
  if (sticky && hero && buy && 'IntersectionObserver' in window) {
    var pastHero = false, overBuy = false;
    var update = function () {
      var show = pastHero && !overBuy;
      sticky.hidden = !pastHero;
      sticky.classList.toggle('is-hidden', !show);
    };
    new IntersectionObserver(function (es) { es.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.bottom < 0; update(); }); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(function (es) { es.forEach(function (e) { overBuy = e.isIntersecting; update(); }); }, { threshold: 0.15 }).observe(buy);
  }

  /* ---------- Count-up stats ---------- */
  var counters = $$('[data-count]', root);
  if (counters.length && 'IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = parseFloat(el.getAttribute('data-count')), dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
        var t0 = null, dur = 1100;
        var step = function (ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur); k = 1 - Math.pow(1 - k, 3);
          el.textContent = (end * k).toFixed(dec);
          if (k < 1) requestAnimationFrame(step); else el.textContent = end.toFixed(dec);
        };
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { io.observe(c); });
  }

  /* ---------- Chart reference line ---------- */
  function placeRef() {
    var ref = $('.tlp-chart__ref', root); var track = $('.tlp-bar--hero .tlp-bar__track', root); var bars = $('.tlp-chart__bars', root);
    if (!ref || !track || !bars) return;
    var v = parseFloat(ref.style.getPropertyValue('--v')) || 20;
    var max = parseFloat(bars.style.getPropertyValue('--max')) || 30;
    var tr = track.getBoundingClientRect(), br = bars.getBoundingClientRect();
    ref.style.left = (tr.left - br.left + tr.width * (v / max)) + 'px';
    ref.classList.add('is-ready');
  }
  placeRef();
  window.addEventListener('resize', placeRef);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeRef);

  /* ---------- Init ---------- */
  selectVariant(DEFAULT_ID, { keepImage: true });
  loadCart().catch(function () {});
})();
